import styled from "styled-components";
import { colors } from "../../styles/Colors";
import { TextBold } from "../../styles/GlobalStyledComponents";
import BackgroungMobile from "../../assets/images/Background/backgroundMobile.webp";

export const ProyectContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  align-content: space-between;
  width: 100%;
  padding-top: 20px;
  /* min-width: 692px; */
  height: 100%;

  @media (max-width: 850px) {
    min-height: auto;
    margin: 0 30px;
  }
  @media (max-width: 650px) {
    margin: 0px;
    padding-top: 0px;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

export const HeaderCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
`;

export const Title = styled.h3`
  font-size: 20px;
  font-weight: 400;
  text-transform: uppercase;
  /* letter-spacing: 1px; */
`;

export const HeaderTextWrapper = styled.div`
  flex-grow: 1;
`;

export const LineHeader = styled.hr`
  max-width: 100%;
  border: 0.5px solid #dddddd;
`;

export const HeaderTitle = styled.div`
  width: 100%;
  padding: 0 60px 0 20px;
`;

export const HeaderMenu = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  background-color: ${(props) => props.theme.colors.white};
  max-width: 700px;
  width: 100%;
  margin-bottom: 10px;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 4px 0px 16px 0px #08547514;
  gap: 12px;
  @media (max-width: 650px) {
    width: 95%;
    margin: 8px auto;
  }
  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const ContainerBackgroundMenu = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: inherit;
  max-width: 700px;
  @media (max-width: 650px) {
    max-width: none;
    width: 100%;
    flex-direction: column;
    justify-content: flex-start;
    background-image: url(${BackgroungMobile});
    background-size: cover;
    background-repeat: no-repeat;
    padding: 8px 0;
  }
  @media screen and (max-width: 600px) {
    padding: 8px 15px;
  }
`;

export const HeaderTexts = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  @media (max-width: 650px) {
    max-width: 100%;
  }
`;

export const HeaderMenuRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 650px) {
    flex-direction: column;
    gap: 8px;
  }
`;

export const HeaderSubMenuOne = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media screen and (max-width: 650px) {
    display: flex;
    align-items: center;
    width: 100%;
  }
`;

interface HeaderSubMenuProps {
  $coStyles?: boolean;
}

export const HeaderSubMenuTwo = styled.div<HeaderSubMenuProps>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  max-width: ${(props) => (props.$coStyles ? "300px" : "220px")};
  padding: 8px;
  background-color: ${colors.white};

  @media screen and (max-width: 650px) {
    width: 100%;
    max-width: 100%;
    background-color: unset;
  }
`;

export const HeaderInformationText = styled.span``;

export const SubMenuPrice = styled.div`
  display: flex;
  width: 100%;
  align-items: baseline;
  gap: 10px;
`;

export const Price = styled(TextBold)`
  line-height: 24px;

  @media screen and (max-width: 650px) {
    font-size: 16px;
  }
`;

export const Currency = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: ${colors.gray0};
`;

export const DetailInformation = styled.span<HeaderSubMenuProps>`
  display: flex;
  align-items: center;
  cursor: pointer;
  visibility: ${(props) => (props.$coStyles ? "none" : "hidden")};
`;

export const PendingDebtTitle = styled.span`
  display: flex;
  width: 100%;
  justify-content: flex-start;
`;

export const SubMenuDebt = styled.div`
  display: flex;
  @media screen and (max-width: 600px) {
    width: auto;
  }
`;

export const PriceDetailWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
`;

export const MoneyWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const BodyWrapper = styled.div`
  /* flex-direction: column; */
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  min-height: 624px;
  margin-bottom: 10px;

  @media (max-width: 650px) {
    font-size: 11px;
  }
`;

interface DetailModalProps {
  open?: boolean;
}

export const DetailOverlay = styled.div<DetailModalProps>`
  display: ${(props) => (props.open ? "block" : "none")};
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;
  cursor: pointer;
`;

interface ShowDetailTextProps {
  open: boolean;
}

export const ShowDetailText = styled.img<ShowDetailTextProps>`
  display: none;
  @media screen and (max-width: 600px) {
    display: block;
    transform: ${(props) =>
      props.open ? "rotate(-270deg)" : "rotate(-90deg)"};
    cursor: pointer;
  }
`;

export const LandingHeader = styled.div`
  width: 100%;
  height: 100%;
  min-height: 80px;
  background-color: ${(props) => props.theme.colors.red11};
  display: flex;
`;

export const LandingHeaderBg = styled.div`
  width: 100%;
  height: 100%;
  background-image: url("LandingHeaderBg.svg");
  background-size: contain;
  background-repeat: no-repeat;
  max-width: 30%;
`;

export const LandingHeaderImg = styled.img`
  width: fit-content;
  height: 100%;
`;
